export enum BuildingRouteNames {
  BuildingSelection = 'BuildingSelection',
  BottomTabs = 'BottomTabs',
}
